module.exports = __webpack_public_path__ + "familles-fromage.e91bc7592a722ddfd2ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plats/familles-fromage.jpg
// module id = 635
// module chunks = 1